//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { ReportFormat } from './Enums';

export class AttendanceReportSettings extends ItemBase {
    StudentIDs: string[] = [];
    StartDate: string = "1970-01-01T00:00:00";
    EndDate: string = "1970-01-01T00:00:00";
    Format: ReportFormat = ReportFormat.PDF;
    IncludeTeacherNote: boolean = false;
    IncludeParentNote: boolean = false;
    IncludeStudentNote: boolean = false;
    Note: string | null = null;

    constructor(initializer?: Partial<AttendanceReportSettings>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "AttendanceReportSettings";
}
